module.exports = __webpack_public_path__ + "static/media/logo-zero-512.ee65aa57.png";